import { RefObject, useEffect, useState } from 'react'

const useObservedWidth = (ref: RefObject<HTMLElement>) => {
  const [width, setWidth] = useState(1)

  useEffect(() => {
    const element = ref.current
    if (!element) return
    const updateWidth = () => setWidth(Math.max(element.clientWidth, 1))
    updateWidth()
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', updateWidth)
      return () => window.removeEventListener('resize', updateWidth)
    }
    const observer = new ResizeObserver(() => updateWidth())
    observer.observe(element)
    return () => observer.disconnect()
  }, [ref])

  return width
}

export default useObservedWidth
